import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-bg relative z-10 flex flex-col lg:flex-row">
      {/* left brand panel */}
      <div className="hidden lg:flex lg:w-1/2 relative dot-grid border-r border-border overflow-hidden">
        <div className="absolute -bottom-40 -left-20 w-[500px] h-[500px] rounded-full" style={{ background: "radial-gradient(circle, rgba(0,229,255,0.12), transparent 65%)" }} />
        <div className="relative p-14 flex flex-col justify-between">
          <Logo size="text-2xl" />
          <div>
            <h2 className="font-display text-4xl font-extrabold leading-tight max-w-md">
              Ne laissez plus vos consultants <span className="brand-ko">entre deux missions.</span>
            </h2>
            <p className="text-muted mt-4 max-w-sm">
              L'IA qui détecte les entreprises ayant besoin des compétences de vos consultants.
            </p>
          </div>
          <p className="font-mono text-xs text-muted">interKO.io — Intelligence commerciale pour les ESN</p>
        </div>
      </div>

      {/* right form panel */}
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8"><Logo size="text-2xl" /></div>
          <h1 className="font-display text-3xl font-bold mb-2">{title}</h1>
          {subtitle && <p className="text-muted mb-8">{subtitle}</p>}
          {children}
          {footer && <div className="mt-6 text-sm text-muted text-center">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
